import { faCircleCheck, faPenCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import type { AnyObjectSchema } from 'yup';

import { useThemeContext } from '../../../../app/theme-provider';
import { useSteps } from '../steps/use-steps';

import styles from './index.module.scss';

interface WizardEventResult {
  success: boolean;
  onSuccess?: number | string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type WizardEventCallback<T = any> = (
  isValid: boolean
) => WizardEventResult | Promise<WizardEventResult>;

export interface WizardStepProps<T = any> {
  title: string;
  path: string;
  element: any;
  schema: AnyObjectSchema;
  name?: string;
  onExit?: WizardEventCallback<T>;
  onSubmit?: WizardEventCallback<T>;
}

export const WizardStep = ({ index }: { index: number }) => {
  const { theme } = useThemeContext();
  const { steps, currentStepIndex } = useSteps();
  const { clearErrors } = useFormContext();
  const step = steps[index];
  const isActive = currentStepIndex === index;
  const isStepCompleted = currentStepIndex > index;
  const futureStep = currentStepIndex < index;

  return (
    <Col className={classNames(styles.step, 'mt-2 mt-md-0')}>
      {futureStep && (
        <>
          <div
            aria-label="Future Step"
            className={classNames(styles.icon, {
              [styles.isActive]: isActive,
              [styles.isPrevious]: isStepCompleted,
            })}
          >
            {index + 1}
          </div>
          <div className="text-wrap text-center">{step.title}</div>
        </>
      )}
      {isActive && (
        <>
          <FontAwesomeIcon icon={faPenCircle} size="2x" color="orange" />
          <div className="text-wrap text-center">{step.title}</div>
        </>
      )}
      {isStepCompleted && (
        <Link
          style={{
            color: theme === 'dark' ? 'white' : '#000000',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
          to={step.path}
          onClick={() => clearErrors()}
          className={styles.navigateLink}
        >
          <FontAwesomeIcon icon={faCircleCheck} size="2x" color="green" />
          <div className="text-wrap text-center">{step.title}</div>
        </Link>
      )}
    </Col>
  );
};

export default function WizardStepper() {
  const { steps } = useSteps();
  return (
    <nav>
      <Row
        className={classNames(
          styles.wizardNavigation,
          'd-flex justify-content-between pb-4'
        )}
      >
        {steps.map((step, index) => (
          <WizardStep key={index} index={index} />
        ))}
      </Row>
    </nav>
  );
}
